import React from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'

import './PastVisit.css'
import $t from '../../../../i18n'

const PastVisit = () => {
  const selectedPastVisit = useSelector(
    state => state.medicalInfo?.selectedPastVisit
  )

  return (
    <div className="visit-details">
      <div className="title">
        {`${dayjs(selectedPastVisit?.date).format('DD MMM YYYY h:mm A')}  |  ${
          selectedPastVisit?.doctor
        }`}
      </div>
      <div className="visit-details-rows">
        {selectedPastVisit?.table?.map(({ field, value }) => {
          return (
            <div key={field} className="visit-info">
              <div className="field">{field}</div>
              <div className="value">{value || $t('common.none')}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default PastVisit
